import { useState, forwardRef } from "react";
import { NavLink } from "react-router-dom";
import Cursor from "../components/cursor";
// import logo from "../images/Footer/footer-logo.svg";

// function Footer() {
//     const [isActive, setActive] = useState(false);

//     const handleMouseEnter = e => {
//       setActive(true)
//     }
//     const handleMouseLeave = e => {
//       setActive(false)
//     }
//      return (
//        <>

//        <div className="footer" >
//            <div className="footer-container">
//             <img src={logo} alt="" className="footer__logo" />
//                 <p className="footer__text">
//                     MOSCOW. RUSSIA. WORLDWIDE
//                     <br />
//                     ALL RIGHTS RESERVED
//                 </p>
//                 <div className="footer__contact">
//                     <a className="footer__contact-link" href="mailto:giveme@heroinmarketing.com">giveme@heroinmarketing.com</a>
//                     <a className="footer__contact-link" href="tel:+74994042756">+7 499 404 27 56</a>
//                 </div>
//            </div>
//        </div>
//      </>
//      )
// };

function Footer({ Next, handleMouseEnter, handleMouseLeave }, ref) {
  return (
    <>
      <footer className="footer" ref={ref}>
        <div className="footer__container">
          <div className="footer__block">
            <p className="menu__contacts-title">контакты</p>

            <div className="menu__contacts">
              <p className="menu__contact-item margin-0">Москва, ул.Новодмитровская д. 2, к 2</p>
            </div>

            <div className="menu__contacts">
              <a href="malito:giveme@heroinmarketing.com" className="menu__contact-item" onMouseLeave={handleMouseLeave} onMouseOver={handleMouseEnter}>
                giveme@heroinmarketing.com
              </a>
              <a href="tel:+74994042756" className="menu__contact-item" onMouseLeave={handleMouseLeave} onMouseOver={handleMouseEnter}>
                +7 499 404 27 56
              </a>
            </div>

            <div className="menu__social">
              <a href="https://t.me/heroinmarketing" target="_blank" rel="noopener noreferrer" className="menu__social-item--telegram" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                telegram
              </a>
              <a href="https://instagram.com/heroinmarketing" target="_blank" rel="noopener noreferrer" className="menu__social-item--instagram" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                instagram *
              </a>
            </div>

            <div className="menu__contacts">
              <NavLink onMouseLeave={handleMouseLeave} onMouseOver={handleMouseEnter} to="/politic" className="menu__contact-item">
                политика конфендициальности
              </NavLink>
            </div>

            <p className="footer__legal_mark">* Meta Platforms Inc. признана экстремистской организацией и запрещена в РФ.</p>
          </div>

          <div className="footer__block footer__block--second">
            <div className="footer__min-block">
              <p className="footer__next">далее</p>
              {Next}
            </div>

            <div className="footer__direction ">
              <p className="contact__sumbol">+</p>
              <NavLink onMouseLeave={handleMouseLeave} onMouseOver={handleMouseEnter} to="/contact" className="footer__href">
                contact us
              </NavLink>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default forwardRef(Footer);
